import React, {Component} from 'react';
import {connect} from 'react-redux';
import InputRadio from 'components/atoms/inputs/input-radio';
import {filterObjectByParams, sortArrayOfObjects} from 'helpers/common-helper';
import {SearchRuleBuilder} from 'services/search-rule-builder';
import TeamLogo from 'components/molecules/team-logo';
import SearchPlayer from './search-player';

interface Props {
    matchedPlayerNameSlugs: string[];
    matchedPlayerIds: string[];
    players;
    onChoosePlayer: (player) => void;
}

interface State {
    chosenPlayerId: string;
    searchPlayer: string;
}

class AvailablePlayers extends Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            chosenPlayerId: '',
            searchPlayer: '',
        };
    }
    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        const {matchedPlayerIds: prevMatchedPlayerIds} = prevProps;
        const {matchedPlayerIds} = this.props;

        matchedPlayerIds.length !== prevMatchedPlayerIds.length && this.setState({chosenPlayerId: ''});
    }
    onSearch(value): void {
        this.setState({searchPlayer: value});
    }
    onChoose(player): void {
        this.setState({chosenPlayerId: player.getId()});
        this.props.onChoosePlayer(player);
    }
    getPlayers() {
        const {players, matchedPlayerNameSlugs, matchedPlayerIds} = this.props;
        const {searchPlayer} = this.state;

        let filteredPlayers = players
            .getAllAsArr()
            .filter(
                (player) =>
                    !inArray(player.nameSlug, matchedPlayerNameSlugs) && !inArray(player.getId(), matchedPlayerIds),
            );

        searchPlayer &&
            (filteredPlayers = filterObjectByParams(
                filteredPlayers,
                SearchRuleBuilder.like('name', searchPlayer),
                true,
            ));

        return sortArrayOfObjects(filteredPlayers, 'name', 'asc');
    }
    render() {
        const players = this.getPlayers();

        return (
            <>
                <SearchPlayer value={this.state.searchPlayer} onSearch={this.onSearch.bind(this)} />
                <div className="match-table-holder">
                    <table className="table">
                        <thead>
                            <tr>
                                <th colSpan={4}>Players from Player Pool</th>
                            </tr>
                        </thead>
                        <tbody>
                            {players.map((player, index) => (
                                <tr key={index} onClick={(() => this.onChoose(player)).bind(this)}>
                                    <td className="td-chk">
                                        <InputRadio
                                            value={player.getId()}
                                            checked={player.getId() === this.state.chosenPlayerId}
                                            onChange={(() => this.onChoose(player)).bind(this)}
                                        />
                                    </td>
                                    <td>{player.name}</td>
                                    <td>
                                        <TeamLogo teamName={player.team} />
                                    </td>
                                    <td>{player.positionName}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {!players.length && <div className="match-table-empty">Players were not found.</div>}
                </div>
            </>
        );
    }
}

function mapStatesToProps(state) {
    const {
        playersData: {players},
    } = state;

    return {
        players,
    };
}

export default connect(mapStatesToProps)(AvailablePlayers);
